var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlbumCollection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21,8H3c-1.65,0-3,1.35-3,3v13H24V11c0-1.65-1.35-3-3-3Zm1,14H2V11c0-.55,.45-1,1-1H21c.55,0,1,.45,1,1v11ZM12,12c-3.98,0-8,1.37-8,4s4.02,4,8,4,8-1.37,8-4-4.02-4-8-4Zm0,6c-3.72,0-6-1.29-6-2s2.28-2,6-2,6,1.29,6,2-2.28,2-6,2Zm1.5-2c0,.55-.67,1-1.5,1s-1.5-.45-1.5-1,.67-1,1.5-1,1.5,.45,1.5,1ZM24,3v.03c-.84-.63-1.87-1.03-3-1.03H3c-1.13,0-2.16,.39-3,1.03v-.03C0,1.35,1.35,0,3,0H21c1.65,0,3,1.35,3,3Zm0,4v.03c-.84-.63-1.87-1.03-3-1.03H3c-1.13,0-2.16,.39-3,1.03v-.03c0-1.65,1.35-3,3-3H21c1.65,0,3,1.35,3,3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlbumCollection);
export default __webpack_public_path__ + "static/media/album-collection.41c278de9ce89236e7466a2266c0d2e5.svg";
export { ForwardRef as ReactComponent };